export default "__VITE_ASSET__e4yeY3M0__"